import { useState } from 'react'
import { fbt } from 'fbtee'
import { Send } from 'lucide-react'
import { ScheduleShareDialog } from './ScheduleShareDialog'
import { track, type ScheduleSurface } from '../../../lib/analytics'
import { OptionChip } from '../../../components/OptionChip'
import { useGuestGuard } from '../../../hooks/useGuestGuard'
import { shareSchedulePrompt } from '../../../lib/guestPrompts'
import type { Group } from '../../../types'

// "Share your picks" control in the schedule's "more options" FAB (the header's
// share icon shares the event). An always-visible option: icon-only when the FAB
// is collapsed, labeled when expanded. Only the parent's own-schedule case builds
// it, so it never shows on a shared view. Guests see it too: sharing is where
// their device-only picks hit the sign-up wall.
export function ScheduleShareFab({
  eventId,
  eventName,
  ownerId,
  groups,
  setCount,
  surface,
  expanded,
}: {
  eventId: string
  eventName: string
  ownerId: string | null
  groups: Group[]
  setCount: number
  surface: ScheduleSurface
  /** Show the text label (expanded) or render icon-only (collapsed). */
  expanded?: boolean
}) {
  const [open, setOpen] = useState(false)
  const { isGuest, prompt } = useGuestGuard()
  return (
    <>
      <OptionChip
        icon={<Send className="size-5" />}
        label={fbt('Share picks', 'Schedule chip label to share your set picks')}
        title={fbt('Share your schedule', 'Accessible label for the share-schedule chip')}
        onClick={() => {
          track('schedule_fab_tap', { fab: 'share', surface, event_id: eventId })
          if (isGuest || !ownerId) prompt(shareSchedulePrompt())
          else setOpen(true)
        }}
        showLabel={expanded}
      />
      {ownerId && <ScheduleShareDialog
        open={open}
        onOpenChange={setOpen}
        eventId={eventId}
        eventName={eventName}
        ownerId={ownerId}
        groups={groups}
        setCount={setCount}
      />}
    </>
  )
}
